import {
  PACKAGE_HOME_PATH,
  TOURISTS_PATH,
  PAY_PATH,
} from 'src/routes/Checkout/store/constants';
import { i18n } from '@lt/localization';
import type { Step } from './types';

export const TOUR_CHECKOUT_STEPS: Step[] = [
  {
    id: PACKAGE_HOME_PATH,
    title: i18n.t('checkout.summary.steps.chooseFlight'),
  },
  {
    id: TOURISTS_PATH,
    title: i18n.t('checkout.summary.steps.touristsInfo'),
  },
  {
    id: PAY_PATH,
    title: i18n.t('checkout.summary.steps.services'),
  },
];

export const HOTEL_CHECKOUT_STEPS: Step[] = [
  {
    id: PACKAGE_HOME_PATH,
    title: i18n.t('checkout.summary.steps.guestsInfo'),
  },
  {
    id: PAY_PATH,
    title: i18n.t('checkout.summary.steps.services'),
  },
];

export const TEST_ID_TOPBAR_OPEN_SUMMARY_BTN = 'topbar-open-summary-btn';
